<template>
    <v-dialog v-model="dialog" max-width="750">
        <v-card>
            <v-card-title class="text-h5">
                Entrega de materiales
            </v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>

                    <v-row class="mt-4" dense>
                        <v-col cols="12" md="4">
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="entrega.fecha" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :rules="required_rules" outlined small dense :value="computedDateFormatted" label="Fecha" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="entrega.fecha" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">
                                        Cancelar
                                    </v-btn>
                                    <v-btn text color="primary" @click="$refs.menu.save(entrega.fecha)">
                                        Guardar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-text-field :rules="required_rules" v-model="entrega.observaciones" outlined small dense label="Observaciones"></v-text-field>
                        </v-col>

                    </v-row>
                </v-form>
                <v-row class="mt-0" dense>
                    <v-col cols="12">
                        <v-btn @click="agregarEntrega" dense small depressed class="white--text" color="green">Agregar</v-btn>
                    </v-col>
                </v-row>

                <v-row class="mt-6" dense>
                    <v-col cols="12">
                        <v-data-table dense :headers="headers" :items="items" class="elevation-0">
                            <template v-slot:item.fecha="{ item }">
                                <span>{{item.fecha | date_filter}}</span>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon @click="selectItem(item)" small class=" mr-2" color="blue">mdi-pencil</v-icon>
                                <v-icon @click="deleteItem(item)" small class="mr-2" color="red lighten-1">mdi-trash-can</v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn color="red lighten-1 white--text" small dense depressed @click="dialog = false">cerrar</v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {
        entrega_rules
    } from '../mixins/entrega_rules'

    import moment from "moment"

    export default {
        mixins: [entrega_rules],

        data() {
            return {
                menu: false,
                dialog: false,
                items: [],
                entrega: {
                    id: null,
                    fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                    observaciones: null,
                    temp_id: Math.random().toString(16).slice(2)
                },
                headers: [{
                        text: 'Fecha',
                        value: 'fecha',
                        width: 120
                    },
                    {
                        text: 'Observaciones',
                        value: 'observaciones',
                        sortable: false
                    },
                    {
                        text: 'Acciones',
                        value: 'action',
                        sortable: false
                    },
                ]
            }
        },
        created() {
            this.$parent.$on('open', data => {
                if (data.entrega_material) {
                    this.items = data.entrega_material
                }
                this.dialog = true
            })
        },


        methods: {
            getId(entrega) {
                const field = entrega.id ? 'id' : 'temp_id'
                return {
                    field: field,
                    id: entrega[field]
                }
            },
            deleteItem(item) {
                if (item.id) {
                    return this.deleteEntregaMaterial(item)
                }
                this.spliceItem(this.items, item)
                this.$emit('update_items', this.items)
            },

            deleteEntregaMaterial(item) {
                axios.get(`api/delete-entrega-material/${item.id}`).then(res => {
                    this.spliceItem(this.items, item)
                }, res => {})
            },

            spliceItem(items, item) {
                items.splice(items.indexOf(item), 1)
            },

            agregarEntrega() {
                if (!this.$refs.form.validate()) {
                    return this.$toast.warn('Error validando el formulario')
                }
                let {
                    field,
                    id
                } = this.getId(this.entrega)

                let index = this.items.findIndex(x => x[field] == id)

                if (index > -1) {
                    this.$set(this.items, index, this.entrega)
                } else {
                    this.items.unshift(this.entrega)
                }
                console.log(this.entrega);
                this.$emit('update_items', this.items)

                this.resetEntrega()
            },

            selectItem(item) {
                this.entrega = JSON.parse(JSON.stringify(item))
            },

            resetEntrega() {
                this.$refs.form.resetValidation()
                this.entrega = {
                    id: null,
                    fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                    observaciones: null,
                    temp_id: Math.random().toString(16).slice(2)
                }
            }
        },

        filters: {
            date_filter(value) {
                return moment(value).format("DD-MM-YYYY");
            }
        },

        computed: {
            computedDateFormatted() {
                return moment(this.entrega.fecha).format('DD-MM-YYYY')
            }
        }
    }
</script>